// extracted by mini-css-extract-plugin
export default {"itemsContainer":"KMZTKJ","sectionSeparator":"jo58Xk"};